module.exports = ".alignClose {\n  margin-top: 1em;\n  margin-right: 1em; }\n"